import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import useOnClickOutside from "use-onclickoutside";
import { storeReminders } from "../../../../actions/reminders";
import { icon, number, tooltip } from "../../../../config";
import NotificationsReminder from "../../../Tasks/Reminders/NotificationsReminder";
import ReminderHandler from "../../../Tasks/Reminders/ReminderHandler";
import { ReminderContextProvider } from "../../../Tasks/Reminders/ReminderContextProvider";
import { getReminder } from "../../../Tasks/Reminders/reminder.service";
import ReminderMenu from "../Comments/ReminderMenu";

const TaskReminder = ({ auth }) => {
  const { showTaskDetailPanel } = useSelector((state) => state.sidebarContent);
  const { task, isNewTask } = useSelector((state) => state.taskSidebar);
  const [showReminder, setShowReminder] = React.useState(false);
  const [showQuickReminderMenu, setShowQuickReminderMenu] = React.useState(false);
  const anchorReminder = React.useRef();
  const taskReminderWrapRef = React.useRef(null);
  const [reminderMenuAppendTo, setReminderMenuAppendTo] = React.useState(null);
  const reminderNotif = useSelector((state) => state.reminders?.reminderNotif);
  const { isCustomReminder } = useSelector((state) => state.planMyDay);
  const dispatch = useDispatch();
  /** open reminder popup on custom reminder plan */
  useEffect(() => {
    if (isCustomReminder) {
      setShowReminder(true);
      setShowQuickReminderMenu(false);
    }
  }, [isCustomReminder]);

  /**
   * show hide modal/popup — existing reminder list when task already has reminders; quick menu first when none
   */
  const onClick = () => {
    if (task.reminderCount > number.ZERO) {
      setShowReminder(!showReminder);
      return;
    }
    if (showReminder) {
      setShowReminder(false);
      setShowQuickReminderMenu(false);
      return;
    }
    setShowQuickReminderMenu(!showQuickReminderMenu);
  };

  useOnClickOutside(taskReminderWrapRef, () => {
    setShowQuickReminderMenu((open) => (open ? false : open));
  });

  useEffect(() => {
    if (task) {
      showReminder && task?.taskId && getReminder(auth.user.id, task.taskId);
    }
  }, [showReminder, task.taskId]);

  useEffect(() => {
    dispatch(storeReminders(null));
  }, [task.taskId]);

  useEffect(() => {
    setShowQuickReminderMenu(false);
  }, [task.taskId]);

  return (
    <React.Fragment>
      {!isNewTask && task && (
        <span
          ref={(el) => {
            taskReminderWrapRef.current = el;
            setReminderMenuAppendTo(el);
          }}
          className={`cursor-pointer ${showTaskDetailPanel ? "form-group col-lg-1 col-md-1 col-sm-1 mt-2" : "mt-auto mb-1 ml-2"}`}>
          <Tooltip anchorElement='target' position='bottom' parentTitle='true'>
            <span onClick={onClick} className={`${task.reminderCount > number.ZERO ? "color-dodger-blue" : "color-black"}`} ref={anchorReminder} title={tooltip.REMINDER}>
              {icon.BELL_ICON}
            </span>
          </Tooltip>
        </span>
      )}

      {showQuickReminderMenu && task && task.reminderCount === number.ZERO && (
        <ReminderContextProvider>
          <ReminderMenu
            isTaskReminder
            setShowDrop={() => {}}
            setShowRemindMenu={setShowQuickReminderMenu}
            setShowCustomPopup={(open) => open && setShowReminder(true)}
            comment=''
            anchor={anchorReminder}
            appendTo={reminderMenuAppendTo}
          />
        </ReminderContextProvider>
      )}

      {showReminder && task && <ReminderHandler show={showReminder} onClick={onClick} isNew={isNewTask} anchor={anchorReminder} setShowReminder={setShowReminder} isTaskReminder={true} />}

      {reminderNotif?.reminderId && <NotificationsReminder reminderId={reminderNotif.reminderId} task={task.taskId} anchor={anchorReminder} />}
    </React.Fragment>
  );
};

/**
 * merges ReduxStore with props
 * @param {*} state
 * @returns {state as props}
 */

function mapStateToProps(state) {
  return {
    defaultDetails: state.tasks.defaultDetails,
    auth: state.auth,
  };
}
export default connect(mapStateToProps, null)(TaskReminder);
